<template>
  <v-container fluid>
    <v-form
      ref="FamilyGroupIncluionUpdateForm">
      <v-row justify="center" class="mt-3" ref="top">
        <v-col cols="12 pl-6">
          <h2 class="my-0 primary--text">
            Inclusão de grupo familiar
          </h2>
        </v-col>
        <v-col cols="12">
          <PrincipalInformations
            class="pt-0"
            :isDetail="false"
            :showHeaderPage="true"
            :showAdmissionDate="true"
            :showRegistrationPlate="false"
            :showCardNumber="false"
            @observerHolderInformationData="observerHolderInformationData"
          />
        </v-col>
        <v-col cols="12">
          <PlanInformation
            class="py-0"
            :movementNotAllowed="!isEdit && !isCriticizedCarrier ? false : true"
            :contractedPlanData="contractedPlanData"
            :isDetail="false"
            :showHeaderPage="true"
            :showEligibility="true"
            :showStartValidityDate="true"
            :showEndValidityDate="false"
            :showCancellationReason="false"
            :showFamilyCode="false"
            :showFamilyCodeSequential="false"
            :showGrace="!isRHProtegido"
            :isRHProtegido="isRHProtegido"
            @observerContractedPlan="observerContractedPlan"
            @getCombinedDataPlans="getCombinedDataPlans"
          />
        </v-col>
        <v-col cols="12">
          <ComplementaryInformations
            class="pt-0"
            :propsGenders="genders"
            :propsMaritalStatus="maritalStatus"
            :holderComplementaryData="holderComplementaryData"
            :showHeaderPage="true"
            :isDetail="false"
            :isFreeMovement="isFreeMovement"
            @observerHolderComplementaryData="observerHolderComplementaryData"
            :showRegistrationPlate="true"
          />
        </v-col>
        <v-col cols="12 pt-0">
          <AddressInformations
            class="ml-3"
            :addressData="addressData"
            :isFreeMovement="isFreeMovement"
            :showHeaderPage="true"
            :isDetail="false"
            @observerAddressData="observerAddressData"
          />
        </v-col>
        <v-col cols="12 pt-0">
          <BankInformations
            class="pt-0"
            :showHeaderPage="true"
            :isFreeMovement="false"
            :isDetail="false"
            @observerBankData="observerBankData"
          />
        </v-col>
        <v-col cols="12 pt-0">
          <UploadDocuments
            ref="UploadDocuments"
            class="pt-0 mx-3 ml-6"
            :showEditAndSaveButton="false"
            :movementRecordId="movementRecord.id"
            :documentParams="documentParams"
            :movementType="
                          $route.query && $route.query.movementType
                          ? $route.query.movementType.toUpperCase()
                          : ''"
            :beneficiaryType="$route.query && $route.query.beneficiaryType ? $route.query.beneficiaryType.toUpperCase(): ''"
            @observerDocumentData="observerDocumentData"
            :startSearch="startSearch"
            @searchEnded="finishSearch"
          />
        </v-col>
      </v-row>

      <v-col cols="12 pt-0">
        <DependentsExpansion
          ref="DependentsExpansion"
          class="pt-0"
          :isDetail="false"
          :propsGenders="genders"
          :propsMaritalStatus="maritalStatus"
          :propsKinships="kinships"
          :contractedPlanData="dataPlans"
          :holder="holder"
          :expandedAll="expandedAll"
          @expanded="expandedAll = false"
          @observerDependents="observerDependents"
        />
      </v-col>
    </v-form>

    <div class="px-3" v-if="violations.length > 0">
      <ViolationRulesAlert :violations="violations" />
    </div>

    <v-footer class="my-5">
      <v-row class="d-flex justify-end">
        <v-col cols="12" xs="12" sm="12" md="2" lg="2">
          <v-btn
            x-large
            block
            outlined
            color="primary"
            @click="onClickCancel()"
          >
            Cancelar
          </v-btn>
        </v-col>
        <v-col cols="12" xs="12" sm="12" md="2" lg="2">
          <v-btn
            x-large
            block
            color="primary"
            @click="onClickFinish()"
          >
            Concluir
          </v-btn>
        </v-col>
      </v-row>
    </v-footer>

    <v-dialog v-model="validateGraceModal" persistent max-width="800">
      <v-card width="800" class="rounded-lg">
        <v-card-title class="primary foreground-accent--text text-h5 font-weight-bold px-8 py-4">
          <v-row
            class="d-flex justify-space-between align-center ma-0">
            <span>Incidência de Carência</span>
            <v-icon color="foreground-accent" @click="closeValidateGraceModal()">
              fas fa-times
            </v-icon>
          </v-row>
        </v-card-title>

        <v-card-text class="mt-5 px-8">
          <v-form ref="formFilterExportMovement">
            <v-row justify="start">
              <v-col>
                <p>A movimentação solicitada excede o prazo máximo em relação à Data do Evento. Haverá incidência de carência.</p>
                <p>Deseja <strong>ajustar a data da movimentação</strong> ou <strong>prosseguir com a configuração?</strong></p>
                <div v-for="grace in gracePeriods" :key="`grace-${grace.benefitId}-${grace.policy}`">
                  <p v-if="grace.hasGracePeriod" class="font-weight-bold">
                    {{ getGracePeriodMessage(grace) }}
                  </p>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions
          class="px-8 py-5">
          <v-spacer />
          <v-btn color="primary" width="220px" outlined @click="closeValidateGraceModal()">
            Ajustar data
          </v-btn>
          <v-btn color="primary" width="220px" @click="confirmGracePeriod()">
            Continuar configuração
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="outOfDeadlineModal" persistent max-width="950">
      <v-card width="950" class="rounded-lg">
        <v-card-title class="primary foreground-accent--text text-h5 font-weight-bold px-8 py-4">
          <v-row class="d-flex justify-space-between align-center ma-0">
            <span>Movimentação fora do prazo</span>
            <v-icon color="foreground-accent" @click="closeOutOfDeadlineModal()">
              fas fa-times
            </v-icon>
          </v-row>
        </v-card-title>

        <v-card-text class="mt-5 px-8">
          <v-row justify="start">
            <v-col>
              <p>A movimentação solicitada está acima do prazo máximo de 30 dias em relação à data do evento. Haverá incidência de carência.</p>
              <p>
                Deseja <strong>ajustar a data da movimentação</strong>, <strong>abrir atendimento</strong> para análise do Time de Relacionamento ou <strong>Confirmar</strong> e seguir com a Movimentação com à incidência de carência?
              </p>
              <div v-for="grace in gracePeriods" :key="`deadline-${grace.benefitId}-${grace.policy}`">
                <p v-if="grace.hasGracePeriod" class="font-weight-bold">
                  {{ getGracePeriodMessage(grace) }}
                </p>
              </div>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="px-8 py-5">
          <v-spacer />
          <v-btn color="primary" width="250px" outlined @click="closeOutOfDeadlineModal()">
            Voltar e ajustar
          </v-btn>
          <v-btn color="primary" width="250px" @click="confirmOutOfDeadlineAndSubmit()">
            Abrir atendimento e enviar
          </v-btn>
          <v-btn color="primary" width="250px" @click="confirmOutOfDeadline()">
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="helpdeskConfirmationModal" persistent max-width="800">
      <v-card width="800" class="rounded-lg">
        <v-card-title class="primary foreground-accent--text text-h5 font-weight-bold px-8 py-4">
          <v-row class="d-flex justify-space-between align-center ma-0">
            <span>Atendimento</span>
            <v-icon color="foreground-accent" @click="closeHelpdeskConfirmationModal()">
              fas fa-times
            </v-icon>
          </v-row>
        </v-card-title>

        <v-card-text class="mt-5 px-8">
          <p class="font-weight-bold">{{ getCutOffDateTitle() }}</p>
          <p>
            É importante se atentar à Data de Corte para o envio da movimentação cadastral.
            Movimentações enviadas próximas ou após essa data podem não ser processadas
            no ciclo atual, em razão da necessidade de negociação com a operadora, e podem
            gerar cobrança adicional em fatura.
          </p>
        </v-card-text>

        <v-card-actions class="px-8 py-5">
          <v-spacer />
          <v-btn color="primary" width="120px" @click="closeHelpdeskConfirmationModal()">
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div v-if="isCriticizedBroker" style="position: absolute; z-index: 1;">
      <ViewCriticizedViolationDialog />
    </div>

    <ReleaseMovementModal
      ref="ReleaseMovementModal"
      @close="closeConfirmReturnModal()"
      @confirm="updateStatus()"
    />

    <InfoMovementDialog
      :show="showReleaseInfo" :movementType="movementType"
      :messageType="releaseMessageType"
      @close="closeConfirmReturnModal()"
      :beneficiaryName="holder && holder.name ? formatter.formatToTitleCase(holder.name) : null"
    />

    <FullScreenLoader
      v-if="loaded"
    />

    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="120">
        <div>Carregando...</div>
      </v-progress-circular>
    </v-overlay>

    <SnackbarCustomize ref="SnackbarCustomize"/>

    <CriticismHandlingModal ref="CriticismHandlingModal" @confirm="onClickFinish" />
  </v-container>
</template>

<script>
import Formatters from '@/shared/formatters/formatters';
import Rule from '@/shared/validators/formRules';
import GenderService from '@/services-http/contract/GenderService';
import ContractService from '@/services-http/contract/ContractService';
import MaritalStatusService from '@/services-http/contract/MaritalStatusService';
import KinshipService from '@/services-http/contract/KinshipService';
import PrincipalInformations from '@/components/Beneficiary/Holder/PrincipalInformations.vue';
import PlanInformation from '@/components/Beneficiary/Contracted/PlanInformation.vue';
import ComplementaryInformations from '@/components/Beneficiary/Holder/ComplementaryInformations.vue';
import AddressInformations from '@/components/Beneficiary/Holder/AddressInformations.vue';
import BankInformations from '@/components/Beneficiary/Holder/BankInformations.vue';
import UploadDocuments from '@/components/Beneficiary/Documents/UploadDocuments.vue';
import DependentsExpansion from '@/components/Beneficiary/Dependent/DependentsExpansion.vue';
import VerifyRoutesMixin from '@/shared/mixins/routeManagement/verifyRoutesMixin';
import ViewCriticizedViolationDialog from '@/components/DynamicDialogInformation/ViewCriticizedViolationDialog.vue';
import ViolationRulesAlert from '@/components/CustomAlerts/ViolationRulesAlert.vue';
import UserUtils from '@/shared/utils/user-utils';
import InfoMovementDialog from '@/components/MovementDialog/InfoMovementDialog.vue';
import MovementRecordService from '@/services-http/sdi/MovementRecordService';
import SnackbarCustomize from '@/components/CustomAlerts/SnackbarCustomize.vue';
import MovementRecordFormFieldsToValidate from '@/shared/validators/movementRecordFormFieldsToValidate';
import ReleaseMovementModal from '@/components/ReleaseMovement/ReleaseMovementModal.vue';
import CriticismHandlingModal from '@/components/CustomAlerts/CriticismHandlingModal.vue';
import FullScreenLoader from '@/components/FullScreenLoader/FullScreenLoader.vue';
import AuthorityManagementMixin from '@/shared/mixins/authorityManagement/authorityManagementMixin';
import { store } from '@/shared/observable/store';

export default {
  name: 'FamilyGroupInclusionUpdate',
  components: {
    PrincipalInformations,
    PlanInformation,
    ComplementaryInformations,
    AddressInformations,
    BankInformations,
    UploadDocuments,
    DependentsExpansion,
    InfoMovementDialog,
    ViolationRulesAlert,
    ViewCriticizedViolationDialog,
    SnackbarCustomize,
    ReleaseMovementModal,
    CriticismHandlingModal,
    FullScreenLoader,
  },
  data: () => ({
    holder: {
      name: null,
      document: null,
      admissionDate: null,
    },
    contractedPlanData: {
      financialGroupId: null,
      contractId: null,
      subContractId: null,
      eligibilityId: null,
      planId: null,
      unitId: null,
      unitCode: null,
      unitDescription: null,
    },
    holderComplementaryData: {},
    addressData: {},
    bankData: {},
    movementRecord: {},
    payload: {},
    dataPlans: {},

    hasAuthorityReleaseMovement: false,
    waitingDocumentUpload: false,
    isCriticizedCarrier: false,
    isCriticizedBroker: false,
    isEdit: false,
    overlay: false,
    isFreeMovement: false,
    isRHProtegido: false,
    showReleaseInfo: false,

    waitingRulesApprovalIds: [],
    genders: [],
    maritalStatus: [],
    kinships: [],
    violations: [],
    dependents: [],

    movementType: 'Inclusão de Grupo Familiar',
    successReleaseMessageType: 'RELEASE_SUCCESS',
    errorReleaseMessageType: 'RELEASE_ERROR',
    releaseMessageType: '',
    persistWithCriticism: false,
    validateGraceModal: false,
    outOfDeadlineModal: false,
    helpdeskConfirmationModal: false,
    outOfDeadlineConfirmed: false,
    pendingOutOfDeadlineRecordList: [],
    outOfDeadlineCutOffDate: '',
    gracePeriods: [],
    documentParams: {
      contractId: null,
      carrierId: null,
      movementType: 'INSERT',
      hasGracePeriod: false,
      beneficiaryType: null,
      benefitTypeCode: null,
    },
    startSearch: false,
    expandedAll: false,
    loaded: false,
  }),

  mixins: [
    VerifyRoutesMixin,
    AuthorityManagementMixin,
  ],

  async beforeMount() {
    await this.mapBeneficiaryMovementRecord();
  },

  mounted() {
    this.scrollTo();
    this.verifyFreeMovement();
    this.verifyRouteRHProtegidoMixin();
    this.verifyTypeOperationForMovement();
    this.loadAuthorityMovement();
    this.loadGenders();
    this.loadMaritalStatus();
    this.loadKinships();

    setTimeout(() => {
      this.startSearch = true;
      this.loaded = false;
    }, 2000);
  },

  methods: {
    verifyFreeMovement() {
      if (this.$route.query.freeMovement && (this.$route.query.freeMovement === 'true' || this.$route.query.freeMovement === true)) {
        this.isFreeMovement = true;
      }
    },
    verifyTypeOperationForMovement() {
      if (sessionStorage.getItem('isCriticizedBroker')) {
        this.isCriticizedBroker = true;
      }
      if (sessionStorage.getItem('isCriticizedCarrier')) {
        this.isCriticizedCarrier = true;
      }
      if (sessionStorage.getItem('isEdit')) {
        this.isEdit = true;
      }
    },
    async loadAuthorityMovement() {
      this.hasAuthorityReleaseMovement = this.userUtils.hasAuthorityToAccess({ authority: 'sdi_painel_movimentacoes_cadastrais_liberar_movimentacao' });
    },
    async loadGenders() {
      await this.genderService.FindAll().then((response) => {
        if (response && response.data) {
          this.genders = response.data;
          this.genders.sort((a, b) => (a.description > b.description ? 1 : -1));
        }
      });
    },
    async loadMaritalStatus() {
      await this.maritalStatusService.FindAll().then((response) => {
        if (response && response.data) {
          this.maritalStatus = response.data;
          this.maritalStatus.sort((a, b) => (a.description > b.description ? 1 : -1));
        }
      });
    },
    async loadKinships() {
      await this.kinshipService.FindAll().then((response) => {
        if (response && response.data) {
          this.kinships = response.data.filter((kinship) => kinship.id !== 22
                              || kinship.code !== 'Titular'
                              || kinship.description !== 'Titular');
          this.kinships.sort((a, b) => (a.description > b.description ? 1 : -1));
        }
      });
    },
    async mapBeneficiaryMovementRecord() {
      if (sessionStorage.getItem('movementRecord')) {
        this.movementRecord = await JSON.parse(sessionStorage.getItem('movementRecord'));
        this.holderName = this.movementRecord.holderName ? this.formatter.formatToTitleCase(this.movementRecord.holderName) : null;

        this.holder = {
          name: this.movementRecord.holderName,
          document: this.movementRecord.holderDocumentNumber ? this.formatter.formatDate(this.movementRecord.holderDocumentNumber) : null,
          admissionDate: this.movementRecord.eventDate,
          department: this.movementRecord.costCenterDepartment ? this.movementRecord.costCenterDepartment : null,
          capacityCode: this.movementRecord.taxAllocationCode ? this.movementRecord.taxAllocationCode : null,
          capacityDescription: this.movementRecord.taxAllocationDescription ? this.movementRecord.taxAllocationDescription : null,
        };

        this.contractedPlanData.financialGroupId = this.movementRecord.financialGroupId ? this.movementRecord.financialGroupId : null;
        this.contractedPlanData.contractId = this.movementRecord.contractId ? this.movementRecord.contractId : null;
        this.contractedPlanData.subContractId = this.movementRecord.subContractId ? Number(this.movementRecord.subContractId) : null;
        this.contractedPlanData.eligibilityId = this.movementRecord.contractEligibilityId ? Number(this.movementRecord.contractEligibilityId) : null;
        this.contractedPlanData.planId = this.movementRecord.plan ? Number(this.movementRecord.plan) : null;
        this.contractedPlanData.startValidityDate = this.movementRecord.startDate;
        this.contractedPlanData.hasGracePeriod = this.movementRecord.hasGracePeriod;
        this.contractedPlanData.unitId = this.movementRecord.unitId;
        this.contractedPlanData.unitCode = this.movementRecord.unitCode;
        this.contractedPlanData.unitDescription = this.movementRecord.unitDescription;
        this.addressData = this.movementRecord;

        this.documentParams.carrierId = this.movementRecord.insuranceCarrierId;
        this.documentParams.contractId = this.contractedPlanData.contractId;
        this.documentParams.hasGracePeriod = !!this.movementRecord.hasGracePeriod;
        this.documentParams.movementType = this.movementRecord.movementType;
        this.documentParams.beneficiaryType = this.movementRecord.beneficiaryType;

        this.holderComplementaryData.cellphone = this.movementRecord.cellphoneNumber && this.movementRecord.cellphoneDDD ? this.movementRecord.cellphoneDDD + this.movementRecord.cellphoneNumber : null;
        this.holderComplementaryData.telephone = this.movementRecord.homephoneDDD && this.movementRecord.homephoneNumber ? this.movementRecord.homephoneDDD + this.movementRecord.homephoneNumber : null;
        this.holderComplementaryData.companyDocumentNumber = this.movementRecord.companyDocumentNumber;
        this.holderComplementaryData.motherName = this.movementRecord.motherName;
        this.holderComplementaryData.cns = this.movementRecord.cns;
        this.holderComplementaryData.dnv = this.movementRecord.dnv;
        this.holderComplementaryData.companyName = this.movementRecord.companyName;
        this.holderComplementaryData.pisPasep = this.movementRecord.pisPasep;
        this.holderComplementaryData.registrationPlate = this.movementRecord.registrationPlate;
        this.holderComplementaryData.registration = this.movementRecord.registrationPlate;
        this.holderComplementaryData.nationality = this.movementRecord.nationality;
        this.holderComplementaryData.stateBirth = this.movementRecord.stateBirth;
        this.holderComplementaryData.weight = this.movementRecord.weight;
        this.holderComplementaryData.height = this.movementRecord.height;
        this.holderComplementaryData.rne = this.movementRecord.rne;
        this.holderComplementaryData.email = this.movementRecord.email;
        this.holderComplementaryData.identityDocumentNature = this.movementRecord.natureIdentifyDocument;
        this.holderComplementaryData.identityDocumentNumber = this.movementRecord.rgDocumentIdentify;
        this.holderComplementaryData.identityDocumentEmissionDate = this.movementRecord.rgDocumentIssueDate;
        this.holderComplementaryData.identityDocumentIssuer = this.movementRecord.rgDocumentIssuingBody;
        this.holderComplementaryData.identityDocumentState = this.movementRecord.documentStateIssuer;
        this.holderComplementaryData.identityDocumentCountry = this.movementRecord.documentCountryIssue;
        this.holderComplementaryData.birthDate = this.movementRecord.birthDate;
        this.holderComplementaryData.birthday = this.movementRecord.birthday;
        this.holderComplementaryData.maritalStatus = this.movementRecord.maritalStatus;
        this.holderComplementaryData.gender = this.movementRecord.gender;
        this.holderComplementaryData.job = this.movementRecord.insuredPosition;
        this.holderComplementaryData.employmentRelationship = this.movementRecord.employmentRelationshipId;
        this.holderComplementaryData.workCard = this.movementRecord.professionalCardNumber;
        this.holderComplementaryData.registrationComplement = this.movementRecord.rne;
        this.holderComplementaryData.rne = this.movementRecord.registrationComplement;
      }
    },
    async updateStatus() {
      const movementRecordService = new MovementRecordService();
      this.$refs.ReleaseMovementModal.close();

      if (this.hasAuthorityReleaseMovement && this.waitingRulesApprovalIds.length > 0) {
        const request = {
          ids: [...this.waitingRulesApprovalIds],
          status: 'VALID',
        };

        await movementRecordService.UpdateStatusFromMultipleMovements(request).then(() => {
          this.releaseMessageType = this.successReleaseMessageType;
          this.showReleaseInfo = true;
          this.$refs.SnackbarCustomize.open('success', 'Movimentação liberada com sucesso');
        }).catch(() => {
          this.releaseMessageType = this.errorReleaseMessageType;
          this.showReleaseInfo = true;
          this.$refs.SnackbarCustomize.open('error', 'Ocorreu um erro ao liberar a movimentação');
        });
      } else {
        this.releaseMessageType = this.errorReleaseMessageType;
        this.showReleaseInfo = true;
        this.$refs.SnackbarCustomize.open('error', 'Você não tem permissão para liberar a movimentação');
      }
    },
    openConfirmReturnModal() {
      this.confirmReturnModal = true;
    },
    closeConfirmReturnModal() {
      this.$refs.ReleaseMovementModal.close();
      this.redirectRouter('Movement', { isRHProtegido: this.isRHProtegido }, { movement: 'movement' });
      this.confirmReturnModal = false;
    },
    observerHolderInformationData(data) {
      this.holder = data;
    },
    observerContractedPlan(data) {
      this.contractedPlanData = data;

      this.documentParams.contractId = this.contractedPlanData.contractId;
      this.documentParams.hasGracePeriod = !!this.contractedPlanData.hasGracePeriod;

      this.startSearch = true;
    },
    finishSearch() {
      this.startSearch = false;
    },
    getCombinedDataPlans(data) {
      this.dataPlans = data;
    },
    observerHolderComplementaryData(data) {
      this.holderComplementaryData = data;
    },
    observerAddressData(data) {
      this.addressData = data;
    },
    observerBankData(data) {
      this.bankData = data;
    },
    observerDocumentData(data) {
      this.documents = data;
    },
    observerDependents(data) {
      this.dependents = data;
    },
    formatZipCode(zipCode) {
      if (zipCode.length === 8) {
        const part1 = zipCode.substring(0, 5);
        const part2 = zipCode.substring(5);
        return `${part1}-${part2}`;
      }
      return zipCode;
    },
    onClickCancel() {
      this.redirectRouter('Movement', { isRHProtegido: this.isRHProtegido });
    },
    async onClickFinish(isContinue) {
      if (!this.$refs.FamilyGroupIncluionUpdateForm.validate()) return;

      let dependentValidation = true;

      Object.keys(this.$refs.DependentsExpansion.$refs).forEach((ref, index) => {
        if (ref.startsWith('DependentExpansionForm-')) {
          const docComponentReference = this.$refs.DependentsExpansion.$refs[ref][0];

          if (!docComponentReference.$refs.UploadDocuments.validate()) {
            this.expandedAll = true;

            dependentValidation = false;
          }
        }

        if (ref.startsWith('DependentForm-')) {
          const docComponentReference = this.$refs.DependentsExpansion.$refs[ref][0];

          if (!docComponentReference.validate()) {
            this.expandedAll = true;

            dependentValidation = false;
          }
        }
      });

      if (!dependentValidation) return;

      if (!this.$refs.UploadDocuments.validate()) return;

      this.gracePeriods = [];
      this.outOfDeadlineConfirmed = false;
      this.outOfDeadlineCutOffDate = '';
      this.persistWithCriticism = !!isContinue;
      this.validateValues();
      this.formatPayloadEditAndCriticizedBroker();
      if (this.isRHProtegido) {
        const params = [{
          parentContractId: this.payload.plan.contractId,
          eventDate: this.payload.holder.admissionDate,
          startDate: this.payload.plan.validityDate,
        }];

        this.getValidateGracePeriod(params);
      } else {
        this.processMovementRecordService();
      }
    },
    validateValues() {
      const dependents = this.formatPayloadDependents();
      let objects = [
        this.contractedPlanData,
        this.holderComplementaryData,
        this.addressData,
        this.bankData,
        this.holder,
        dependents,
        this.documents,
      ];

      objects = this.formatter.validateEmptyValues(objects);
    },
    formatPayloadEditAndCriticizedBroker() {
      this.payload = {
        plan: this.getContractedPlanData(this.contractedPlanData),
        additionalInfo: this.getAdditionalInfo(this.holderComplementaryData, this.holder),
        address: this.getAddressData(this.addressData, 'payload'),
        bank: this.getBankData(this.bankData),
        holder: this.getHolderData(this.holder),
        dependents: this.formatPayloadDependents(),
        documents: this.documentFormatted(this.documents),
      };
    },
    formatPayloadDependents() {
      const filteredDependents = this.dependents.filter((dependent) => !dependent.isDelete);
      return filteredDependents.map((dependent) => {
        const commonProperties = this.buildCommonDependentProperties(dependent, 'payload');

        return {
          ...commonProperties,
          dependentName: dependent.name,
        };
      });
    },
    formatPayloadDependentsValidateInsert() {
      const filteredDependents = this.dependents.filter((dependent) => !dependent.isDelete);

      return filteredDependents.map((dependent) => {
        const commonProperties = this.buildCommonDependentProperties(dependent, 'validate');

        return {
          ...commonProperties,
          movementRecordParentId: this.movementRecord.id,
          plans: [
            {
              contract: this.contractedPlanData.contractId,
              subcontract: this.contractedPlanData.subContractId,
              eligibility: this.contractedPlanData.eligibilityPertainingPlan,
              plan: this.contractedPlanData.planId,
              validityDate: this.contractedPlanData.startValidityDate
                ? this.formatter.formatDateBRtoString(this.contractedPlanData.startValidityDate)
                : null,
            },
          ],
        };
      });
    },
    buildCommonDependentProperties(dependent, typeRequest) {
      const commonProperties = {
        movementRecordId: dependent.id,
        birthDate: dependent.birthDate ? this.formatter.formatDateBRtoString(dependent.birthDate) : null,
        cns: dependent.cns,
        dnv: dependent.dnv ? this.formatter.unmaskDnv(dependent.dnv) : null,
        motherName: dependent.motherName,
        height: dependent.height,
        weight: dependent.weight,
        stateBirth: dependent.stateBirth,
        documents: this.documentFormatted(dependent.documents),
        registrationComplement: dependent.registrationComplement ? dependent.registrationComplement : null,
        address: dependent.address ? this.getAddressObject(dependent.address) : null,
        telephone: dependent.telephone ? dependent.telephone.replaceAll('(', '').replaceAll(')', '').replaceAll('-', '') : null,
        cellphone: dependent.cellphone ? dependent.cellphone.replaceAll('(', '').replaceAll(')', '').replaceAll('-', '') : null,
        identityDocumentNature: dependent.identityDocumentNature,
        identityDocumentNumber: dependent.identityDocumentNumber,
        identityDocumentEmissionDate: dependent.identityDocumentEmissionDate ? this.formatter.formatDateBRtoString(dependent.identityDocumentEmissionDate) : null,
        identityDocumentIssuer: dependent.identityDocumentIssuer,
        identityDocumentState: dependent.identityDocumentState,
        identityDocumentCountry: dependent.identityDocumentCountry,
        email: dependent.email,
      };

      if (typeRequest === 'validate') {
        commonProperties.fullName = dependent.name;
        commonProperties.socialInsuredName = dependent.socialName ? dependent.socialName : null;
        commonProperties.document = dependent.cpf ? this.formatter.removeNonDigit(dependent.cpf) : null;
        commonProperties.maritalStatus = dependent.maritalStatus;
        commonProperties.gender = dependent.gender;
        commonProperties.socialInsuredGenderId = dependent.socialGenderId ? dependent.socialGenderId : null;
        commonProperties.relationship = dependent.degreeKinship;
      } else {
        commonProperties.dependentName = dependent.name;
        commonProperties.socialInsuredName = dependent.socialName ? dependent.socialName : null;
        commonProperties.dependentCpf = dependent.cpf ? this.formatter.removeNonDigit(dependent.cpf) : null;
        commonProperties.maritalStatusId = dependent.maritalStatus;
        commonProperties.genderId = dependent.gender;
        commonProperties.socialInsuredGenderId = dependent.socialGenderId ? dependent.socialGenderId : null;
        commonProperties.degreeKinshipId = dependent.degreeKinship;
      }

      return commonProperties;
    },
    getAddressObject(dependent) {
      const address = {};
      address.zip = dependent.code ? dependent.code.replace('-', '') : null;
      address.log = dependent.log;
      address.city = dependent.city;
      address.state = dependent.region;
      address.type = dependent.logType;
      address.country = dependent.country;
      address.neighborhood = dependent.neighborhood;
      address.number = dependent.number;
      address.complement = dependent.complement;
      address.ibgeCode = dependent.ibgeCode;
      return address;
    },
    documentFormatted(documents) {
      if (documents) {
        return documents.map((element) => ({ id: element.id }));
      }
      return [];
    },
    // async processMovementRecordService() {
    //   this.violations = [];
    //   this.overlay = true;
    //   const movementRecordService = new MovementRecordService();

    //   movementRecordService.ValidateInsert(this.payloadValidateInsert, this.fieldsToValidate.getFieldsToValidate('familyGroup')).then(() => {
    //     movementRecordService.UpdateFamilyGroup(this.movementRecord.id, this.isFreeMovement, this.payload, this.isCriticizedBroker).then((response) => {
    //       const { recordList } = response.data;
    //       const allWithStatusWaitingRulesApproval = recordList.every((movement) => movement.status === 'WAITING_APPROVAL_RULES_VALIDATIONS');
    //       if ((this.hasAuthorityReleaseMovement && allWithStatusWaitingRulesApproval) && this.movementRecord.status !== 'SCHEDULED') {
    //         const releaseMovementData = {
    //           beneficiaryName: this.holder.name,
    //           movementType: this.movementType,
    //         };

    //         this.waitingRulesApprovalIds = recordList.map((movement) => movement.id);
    //         this.$refs.ReleaseMovementModal.open(releaseMovementData);
    //         this.overlay = false;
    //       } else {
    //         this.$refs.SnackbarCustomize.open('success', 'Edição concluída com sucesso');
    //         setTimeout(() => {
    //           this.closeConfirmReturnModal();
    //           this.overlay = false;
    //         }, 1000);
    //       }
    //     }).catch(() => {
    //       this.overlay = false;
    //       this.$refs.SnackbarCustomize.open('error', 'Ocorreu um erro ao tentar editar o cadastro');
    //     });
    //   }).catch((error) => {
    //     this.overlay = false;
    //     if (error.response.status === 422) {
    //       this.violations = [...error.response.data.violations];
    //       this.$refs.CriticismHandlingModal.open();
    //     }
    //   });
    // },
    async processMovementRecordService() {
      this.violations = [];
      this.overlay = true;

      try {
        await this.updateFamilyGroup();
      } catch (error) {
        await this.handleValidationErrors(error);
      } finally {
        this.overlay = false;
      }
    },
    async updateFamilyGroup() {
      this.payload = {
        ...this.payload,
        persistWithCriticism: this.persistWithCriticism ? this.persistWithCriticism : false,
      };
      const movementRecordService = new MovementRecordService();
      const previousCustomDialogState = store.isCustomDialog;
      store.isCustomDialog = true;

      const response = await movementRecordService.UpdateFamilyGroup(this.movementRecord.id, this.isFreeMovement, this.payload, this.isCriticizedBroker)
        .finally(() => {
          store.isCustomDialog = previousCustomDialogState;
        });

      if (this.isOutOfDeadlineResponse(response)) {
        if (!this.outOfDeadlineConfirmed) {
          await this.openOutOfDeadlineModal(response);
        } else {
          this.$refs.SnackbarCustomize.open('error', 'Ocorreu um erro ao enviar a movimentação fora do prazo');
        }
        return;
      }

      const { recordList } = response.data;

      if (this.outOfDeadlineConfirmed) {
        this.pendingOutOfDeadlineRecordList = Array.isArray(recordList) ? recordList : [];
        this.helpdeskConfirmationModal = true;
        return;
      }

      this.finishUpdateFlow(recordList);
    },
    finishUpdateFlow(recordList, closeOnSuccess = false) {
      if (this.shouldOpenReleaseModal(recordList)) {
        this.openReleaseModal(recordList);
      } else if (closeOnSuccess) {
        this.closeConfirmReturnModal();
      } else {
        this.handleSuccessfulEdit();
      }
    },
    shouldOpenReleaseModal(recordList) {
      if (!Array.isArray(recordList)) return false;

      const allWithStatusWaitingRulesApproval = recordList.every((movement) => movement.status === 'WAITING_APPROVAL_RULES_VALIDATIONS');
      return this.hasAuthorityReleaseMovement && allWithStatusWaitingRulesApproval && this.movementRecord.status !== 'SCHEDULED';
    },
    openReleaseModal(recordList) {
      const releaseMovementData = {
        beneficiaryName: this.holder.name,
        movementType: this.movementType,
      };

      this.waitingRulesApprovalIds = recordList.map((movement) => movement.id);
      this.$refs.ReleaseMovementModal.open(releaseMovementData);
    },
    handleSuccessfulEdit() {
      this.$refs.SnackbarCustomize.open('success', 'Edição concluída com sucesso');
      setTimeout(() => {
        this.closeConfirmReturnModal();
      }, 1000);
    },
    async handleValidationErrors(error) {
      if (this.isOutOfDeadlineResponse(error)) {
        if (!this.outOfDeadlineConfirmed) {
          await this.openOutOfDeadlineModal(error);
        } else {
          this.$refs.SnackbarCustomize.open('error', 'Ocorreu um erro ao enviar a movimentação fora do prazo');
        }
        return;
      }

      if (error.response && error.response.status === 422) {
        this.violations = [...error.response.data.violations];

        if (!this.areAllowedToCriticize()) return;

        this.$refs.CriticismHandlingModal.open();
      } else {
        this.$refs.SnackbarCustomize.open('error', 'Ocorreu um erro ao tentar editar o cadastro');
      }
    },
    isOutOfDeadlineResponse(response) {
      const data = response && response.response && response.response.data
        ? response.response.data
        : response && response.data
          ? response.data
          : null;

      return Boolean(data && data.outOfDeadline === true);
    },
    async openOutOfDeadlineModal(response) {
      const data = response && response.response && response.response.data
        ? response.response.data
        : response && response.data
          ? response.data
          : {};

      if (data.gracePeriods && data.gracePeriods.length > 0) {
        this.gracePeriods = data.gracePeriods;
      }

      await this.loadOutOfDeadlineCutOffDate();
      this.outOfDeadlineModal = true;
    },
    closeOutOfDeadlineModal() {
      this.outOfDeadlineModal = false;
    },
    normalizeCutOffDate(cutOffDate) {
      if (cutOffDate === null || cutOffDate === undefined) return '';

      return cutOffDate.toString().trim();
    },
    getLocalOutOfDeadlineCutOffDate() {
      const localCutOffDate = this.normalizeCutOffDate(
        this.contractedPlanData.cutOffDate
        || this.contractedPlanData.cut_off_date
        || this.movementRecord.cutOffDate
        || this.movementRecord.cut_off_date,
      );

      if (localCutOffDate) return localCutOffDate;

      return this.normalizeCutOffDate(
        this.dataPlans && this.dataPlans.movementDeadlineConfig
          ? this.dataPlans.movementDeadlineConfig.cut_off_date
          : null,
      );
    },
    async loadOutOfDeadlineCutOffDate() {
      const localCutOffDate = this.getLocalOutOfDeadlineCutOffDate();

      if (localCutOffDate) {
        this.outOfDeadlineCutOffDate = localCutOffDate;
        return;
      }

      const contractId = this.contractedPlanData.contractId
        || (this.payload && this.payload.plan ? this.payload.plan.contractId : null)
        || this.movementRecord.contractId;

      if (!contractId) {
        this.outOfDeadlineCutOffDate = '';
        return;
      }

      const response = await this.contractService.FindById(contractId).catch(() => null);
      const contract = response && response.data ? response.data : {};

      this.outOfDeadlineCutOffDate = this.normalizeCutOffDate(contract.cut_off_date || contract.cutOffDate);
    },
    getCutOffDateTitle() {
      const cutOffDate = this.outOfDeadlineCutOffDate ? this.outOfDeadlineCutOffDate.toString().trim() : '';

      if (!cutOffDate) return 'Atenção - Data de Corte';
      if (cutOffDate.includes(',')) return `Atenção - Data de Corte - Dias ${cutOffDate}`;
      if (/^\d+$/.test(cutOffDate)) return `Atenção - Data de Corte - Dia ${cutOffDate}`;

      return `Atenção - Data de Corte - ${cutOffDate}`;
    },
    confirmOutOfDeadline() {
      this.outOfDeadlineConfirmed = true;
      this.closeOutOfDeadlineModal();

      if (this.payload && this.payload.plan) {
        this.payload.plan.hasAcceptedGracePeriod = true;
      }

      this.processMovementRecordService();
    },
    confirmOutOfDeadlineAndSubmit() {
      this.outOfDeadlineConfirmed = true;
      this.closeOutOfDeadlineModal();

      if (this.payload && this.payload.plan) {
        this.payload.plan.hasAcceptedGracePeriod = false;
      }

      this.processMovementRecordService();
    },
    closeHelpdeskConfirmationModal() {
      const recordList = Array.isArray(this.pendingOutOfDeadlineRecordList)
        ? [...this.pendingOutOfDeadlineRecordList]
        : [];

      this.helpdeskConfirmationModal = false;
      this.outOfDeadlineConfirmed = false;
      this.pendingOutOfDeadlineRecordList = [];
      this.outOfDeadlineCutOffDate = '';

      if (recordList.length > 0) {
        this.finishUpdateFlow(recordList, true);
        return;
      }

      this.closeConfirmReturnModal();
    },
    areAllowedToCriticize() {
      if (!this.hasPermission('sdi_mov_prosseguir_critica') && this.violations && this.violations.length > 0) {
        this.$refs.SnackbarCustomize.open('error', 'Erro de validação de regras no preenchimento do formulário');
        return false;
      }

      return true;
    },
    getContractedPlanData(data) {
      return {
        contractId: data.contractId,
        subContractId: data.subContractId,
        eligibilityId: data.eligibilityId,
        planId: data.planId,
        validityDate: data.startValidityDate ? this.formatter.formatDateBRtoString(data.startValidityDate) : null,
        financialGroupId: data.financialGroupId,
        hasAcceptedGracePeriod: data.hasGracePeriod,
        unitId: data.unitId,
        unitCode: data.unitCode,
        unitDescription: data.unitDescription,
      };
    },
    getAddressData(data, typeRequest) {
      const addressData = {
        log: data.log,
        city: data.city,
        country: data.country,
        neighborhood: data.neighborhood,
        number: data.number,
        complement: data.complement,
        ibgeCode: data.ibgeCode,
      };
      const codeFormated = data.code ? data.code.replaceAll('-', '') : null;
      if (typeRequest === 'validate') {
        addressData.logType = data.logType;
        addressData.code = codeFormated;
        addressData.region = data.region;
      } else {
        addressData.type = data.logType;
        addressData.zip = codeFormated;
        addressData.state = data.region;
      }

      return addressData;
    },
    getBankData(data) {
      return {
        code: data.code ? Number(data.code) : null,
        agency: data.agency ? Number(data.agency) : null,
        agencyDigit: data.agencyDigit ? Number(data.agencyDigit) : null,
        account: data.account ? Number(data.account) : null,
        accountDigit: data.accountDigit ? Number(data.accountDigit) : null,
      };
    },
    getHolderData(data) {
      const formattedDate = this.holder.admissionDate ? this.holder.admissionDate.includes('/') : null;
      return {
        admissionDate: formattedDate ? this.formatter.formatDateBRtoString(data.admissionDate) : data.admissionDate,
        cpf: data.document ? this.formatter.removeNonDigit(data.document) : null,
        name: data.name,
        socialHolderName: data.socialName ? data.socialName : null,
      };
    },
    getAdditionalInfo(data, holder) {
      const cleanCellphone = data.cellphone ? data.cellphone.replaceAll('(', '').replaceAll(')', '').replaceAll('-', '') : null;
      const cleanTelephone = data.telephone ? data.telephone.replaceAll('(', '').replaceAll(')', '').replaceAll('-', '') : null;
      const formatCompanyDocumentNumber = data.companyDocumentNumber ? data.companyDocumentNumber.replace(/[^A-Za-z0-9]/g, '') : null;

      return {
        motherName: data.motherName,
        cns: data.cns,
        dnv: data.dnv,
        companyName: data.companyName,
        companyDocumentNumber: formatCompanyDocumentNumber,
        pisPasep: data.pisPasep,
        registrationPlate: data.registrationPlate,
        registration: data.registrationPlate,
        nationality: data.nationality,
        stateBirth: data.stateBirth,
        weight: data.weight,
        height: data.height,
        rne: data.rne,
        email: data.email,
        identityDocumentNature: data.identityDocumentNature,
        identityDocumentNumber: data.identityDocumentNumber,
        identityDocumentEmissionDate: data.identityDocumentEmissionDate ? this.formatter.formatDateBRtoString(data.identityDocumentEmissionDate) : null,
        identityDocumentIssuer: data.identityDocumentIssuer,
        identityDocumentState: data.identityDocumentState,
        identityDocumentCountry: data.identityDocumentCountry,
        birthDate: data.birthDate ? this.formatter.formatDateBRtoString(data.birthDate) : null,
        birthday: data.birthDate ? this.formatter.formatDateBRtoString(data.birthDate) : null,
        cellphone: cleanCellphone,
        telephone: cleanTelephone,
        maritalStatusId: data.maritalStatus,
        maritalStatus: data.maritalStatus,
        genderId: data.gender,
        gender: data.gender,
        socialGenderId: data.socialGenderId ? data.socialGenderId : null,
        insuredPosition: data.job,
        job: data.job,
        costCenterDepartment: holder && holder.department ? holder.department : null,
        department: holder && holder.department ? holder.department : null,
        taxAllocationCode: holder && holder.capacityCode ? holder.capacityCode : null,
        capacityCode: holder && holder.capacityCode ? holder.capacityCode : null,
        taxAllocationDescription: holder && holder.capacityDescription ? holder.capacityDescription : null,
        capacityDescription: holder && holder.capacityDescription ? holder.capacityDescription : null,
        employmentRelationshipId: data.employmentRelationship ? Number(data.employmentRelationship) : null,
        employmentRelationship: data.employmentRelationship ? Number(data.employmentRelationship) : null,
        professionalCardNumber: data.workCard,
        workCard: data.workCard,
        registrationComplement: data.registrationComplement ? data.registrationComplement : null,
      };
    },
    scrollTo() {
      this.$refs.top.scrollIntoView({ behavior: 'smooth' });
    },
    getValidateGracePeriod(params) {
      this.contractService.ValidateGracePeriod(params).then((response) => {
        if (response) {
          let hasGracePeriod = false;
          response.data.forEach((element) => {
            if (element.hasGracePeriod === true) {
              hasGracePeriod = true;
              this.gracePeriods = response.data;
            }
          });
          if (hasGracePeriod) {
            this.validateGraceModal = true;
          } else {
            this.payload.plan.hasAcceptedGracePeriod = null;
            this.processMovementRecordService();
          }
        }
      }).catch(() => {
        this.$refs.SnackbarCustomize.open('error', 'Ocorreu um erro ao validar carência');
      });
    },
    closeValidateGraceModal() {
      this.validateGraceModal = false;
    },
    getGracePeriodMessage(grace) {
      return `${grace.benefitId} - ${grace.policy} - Acima do prazo máximo de ${grace.daysGracePeriod} dias.`;
    },
    async confirmGracePeriod() {
      this.payload.plan.hasAcceptedGracePeriod = true;
      this.closeValidateGraceModal();
      await this.openOutOfDeadlineModal();
    },
    nonConfirmGracePeriod() {
      this.payload.plan.hasAcceptedGracePeriod = false;
      this.closeValidateGraceModal();
      this.processMovementRecordService();
    },
  },

  async created() {
    this.loaded = true;

    this.userUtils = new UserUtils();
    this.formatter = new Formatters();
    this.rule = new Rule();
    this.genderService = new GenderService();
    this.maritalStatusService = new MaritalStatusService();
    this.kinshipService = new KinshipService();
    this.movementRecordService = new MovementRecordService();
    this.fieldsToValidate = new MovementRecordFormFieldsToValidate();
    this.contractService = new ContractService();
  },
};
</script>
